export const creditCardKeys = {
	list: (params: { guestId: number }) => ["credit-cards", params],
	add: () => ["credit-cards", "add"],
	delete: (params: { guestId: number; creditCardId: number }) => [
		"credit-cards",
		"delete",
		params,
	],
	getById: (card_id: number) => ["get_card", card_id],
};
